<script>

import Layout from "../../layouts/main";
import Heading from "../../layouts/heading";
import JsonForm from "../../layouts/form";
import { v4 as uuidv4 } from 'uuid';
import api from "../../../api";
import Swal from "sweetalert2";
import simplebar from "simplebar-vue";
import { pages } from "./data";

export default {
  components: { Layout, simplebar, JsonForm, Heading },
  data() {
    return {
      topics: [],
      currentTopicData: null,
      currentTopicId: null,
      currentTopicActiveStatus: true,
    };
  },
  computed: {
    pageData() {
      return pages.filter(element => element.slug == this.$route.fullPath.split('/admin/')[1])[0];
    },
    tableData() {
      // var arr = {};
      if(this.pageData.table)
      {
        return this.currentTopicData.permissions;
      }
      return {};
    },
    totalTopics() {
      return this.topics.length;
    },
    activeTopics() {
      var count = 0;
      for (var x of this.topics) {
        if (x.active) {
          count++;
        }
      }
      return count;
    },
  },
  methods: {
    selectedTopic(data) {
      this.currentTopicId = data.id
      this.currentTopicData = data
      this.currentTopicActiveStatus = data.active
    },
    activateToggle() {
      this.currentTopicActiveStatus = !this.currentTopicActiveStatus
    },
    getPages() {
      api.get(this.pageData.api)
      .then(response => {
        this.topics = response.data
      })
      .catch(e => {
        console.log(e)
      })  
    },
    create(val) {
      if(val)
      {
        var data = {
          uuid: uuidv4(),
        };

        for (const [key, value] of Object.entries(this.pageData.backendVars)) {
          data[key] = val[key] ? val[key] : value;
        }
        
        api.post(this.pageData.api, data)
        .then((response) => {
          // console.log(response);
          this.topics.push(response.data)

        }, (error) => {
          console.log(error);
        });
      }
    },
    update() {

      var data = {};

      for (const [key] of Object.entries(this.pageData.backendVars)) {
        data[key] = this.currentTopicData[key];
      }

      data.active = this.currentTopicActiveStatus

      if(this.pageData.activeConfig && this.pageData.activeConfig.activeMode == 'single')
      {
        if(this.currentTopicActiveStatus != this.currentTopicData.active)
        {
          let where = {
            active: true,
          };
          if(this.pageData.activeConfig && this.pageData.activeConfig.activeRule)
          {
            where[this.pageData.activeConfig.activeRule] = this.currentTopicData[this.pageData.activeConfig.activeRule]
          }
          api.patch(this.pageData.api + '?where=' + JSON.stringify(where), { active: false })
          .then(() => {
              // Swal.fire("Topic Updated!", "Topic Updated Successfully!", "success");
          }, (error) => {
            console.log(error);
          });
        }
      }

      api.patch(this.pageData.api + this.currentTopicId, data)
      .then(() => {
          // this.getPages()
          this.topics.find(v => v.id == this.currentTopicId).active = this.currentTopicActiveStatus;
          Swal.fire("Topic Updated!", "Topic Updated Successfully!", "success");
          if(this.pageData.api == '/api/roles/')
          {
          let where2 = {
            role: this.currentTopicId,
          };
          console.log(data)
            api.patch('/api/users' + '?where=' + JSON.stringify(where2), { permissions: data.permissions })
            .then(() => {
                // Swal.fire("Topic Updated!", "Topic Updated Successfully!", "success");
            }, (error) => {
              console.log(error);
            });
          }
      }, (error) => {
        console.log(error);
      });
    },
    deleted() {
      var self = this;
      api.delete(this.pageData.api + this.currentTopicId)
      .then(() => {
        Swal.fire("Topic Deleted!", "Topic Deleted Successfully!", "warning");
        this.topics.splice(this.topics.findIndex(function(i){
          return i.id === self.currentTopicId;
        }), 1);
        this.currentTopicData = null
      }, (error) => {
        console.log(error);
      });
    },
  },
  watch: {
    pageData() {
      this.currentTopicData = null,
      this.getPages();
    },
    currentTopicData: function (val) {
      if(val != null)
      {     
        this.pageData.deleteBtn = true;
        if(this.$route.fullPath.split('/admin/')[1] != 'roles')
        {
          this.pageData.activeBtn = true;
        }
        this.pageData.submitBtn = true;
        this.currentTopicActiveStatus = this.currentTopicData.active;
      }
    },
  },
  mounted() {
    this.getPages()
  },
};
</script>

<template>
  <Layout>
    <Heading :page="pageData" :activeStatus="currentTopicActiveStatus" @activateToggle="activateToggle"
    @created="create" @deleted="deleted" @form-submitted="update"></Heading>

    <div v-if="topics.length" class="d-lg-flex mb-4">
      <div class="chat-leftsidebar w-25 pr-4 pt-3">
        <div>
          <div class="d-flex mb-2">
            <h5 class="font-size-14 pr-2 my-2 align-self-sm-center">Select a topic</h5>
            <img id="info_tooltip" class="align-self-center mx-2"
            src="@/assets/images/info.svg" alt="">
            <b-tooltip target="info_tooltip">Choose a topic</b-tooltip>            
            <p class="font-size-14 px-3 mb-2 mt-2 text-muted ml-auto">
              <span>Total: {{totalTopics}} </span>
              <span v-if="this.$route.fullPath.split('/admin/')[1] != 'roles'">| Active: {{activeTopics}}</span>
            </p>
          </div>
          <simplebar style="max-height: 345px" id="scrollElement">
            <ul class="list-unstyled chat-list">
              <li
                v-for="data of topics"
                :key="data.id"
                @click="selectedTopic(data)"
                :class="{ active: currentTopicData == data }"
              >
                <a href="javascript: void(0);">
                  <div class="media">
                    <div class="media-body overflow-hidden p-0 p-2">
                      <p class="text-truncate font-size-14 mb-0">
                        {{ data.name }}
                      </p>
                    </div>
                  </div>
                </a>
              </li>
            </ul>
          </simplebar>
        </div>
      </div>
      <div class="w-100 mt-4 mt-sm-0" style="border-left: 1px solid #DADCE3;"
      v-if="currentTopicData">
        <div class="py-3 pl-lg-4">
          <div class="row px-2">
            <JsonForm :schema="pageData.pageSchema" :formData="currentTopicData"></JsonForm>

            <div v-if="this.pageData.table" class="table-responsive">
              <table class="table table-bordered mb-0" style="hyphens: auto;">
                <thead>
                  <tr>
                    <th class="text-capitalize" v-for="cols in pageData.tableCols" v-bind:key="cols.key">{{cols.key}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(value, rkey) in tableData" v-bind:key="rkey">
                    <td v-for="cols in pageData.tableCols" v-bind:key="cols.key">
                      <div v-if="cols.type == 'checkbox'" style="width: 20px">
                        <input
                          v-model="currentTopicData.permissions[rkey][cols.key]"
                          :type="cols.type"
                          class="form-control"
                        />
                      </div>
                      <span v-else>{{v = cols.key == 'name'? rkey : value[cols.key]}}</span>
                    </td>
                  </tr>
                  <!-- <tr v-for="(value, key) in tableData" v-bind:key="key">
                    <td v-for="cols in pageData.tableCols" v-bind:key="cols.key">
                      <div v-if="cols.type == 'text' || 
                      cols.type == 'date' || cols.type == 'number' || 
                      cols.type == 'email' || cols.type == 'password' ||
                      cols.type == 'checkbox' || cols.type == 'radio'">
                        <input
                          v-model="currentTopicData.table[key][cols.key]"
                          :type="cols.type"
                          class="form-control"
                          :class="cols.type == 'checkbox' || cols.type == 'radio' ? 'w-50' : ''"
                        />
                      </div>
                      <div v-else-if="cols.type == 'select'">
                        <select class="form-control" v-model="currentTopicData.table[key][cols.key]">
                          <option v-for="option in cols.options" v-bind:key="option"
                          :selected="currentTopicData.table[key][cols.key] == option">{{option}}</option>
                        </select>
                      </div>
                      <b-form-group v-else-if="cols.type == 'time'">
                        <b-form-input id="time" v-model="currentTopicData.table[key][cols.key]"
                        :type="cols.type"></b-form-input>
                      </b-form-group>
                      <span v-else>{{v = cols.key == 'name'? key : value[cols.key]}}</span>
                    </td>
                  </tr> -->
                </tbody>
              </table>
            </div>

            <!-- <div v-if="pageData.tables" class="table-responsive mb-0">

              <b-table
                :items="tableData"
                :fields="pageData.tableCols"
                responsive="sm"
              >
            <template v-slot:cell()="row">
              <div v-if="row.field.type == 'text' || 
              row.field.type == 'date' || row.field.type == 'number' || 
              row.field.type == 'email' || row.field.type == 'password' ||
              row.field.type == 'checkbox' || row.field.type == 'radio'">
                <input
                  :id="row.index"
                  v-model="currentTopicData.table[row.index][row.field.key]"
                  :type="row.field.type"
                  class="form-control"
                  :class="row.field.type == 'checkbox' || row.field.type == 'radio' ? 'w-50' : ''"
                />
              </div>
              <b-form-group v-else-if="row.field.type == 'time'">
                <b-form-input id="time" v-model="currentTopicData.table[row.index][row.field.key]"
                :type="row.field.type"></b-form-input>
              </b-form-group>
              <div v-else-if="row.field.type == 'select'">
                <select class="form-control" v-model="currentTopicData.table[row.index][row.field.key]">
                  <option v-for="option in row.field.options" v-bind:key="option"
                  :selected="currentTopicData.table[row.index][row.field.key] == option">{{option}}</option>
                </select>
              </div>
              <p v-else>{{row.value}}</p>
            </template>
              </b-table>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>